import Button, { ButtonVariant } from 'components/common/Button/Button';
import StarIcon from '@mui/icons-material/Star';

/**
 * Examples of Scalyr's button component
 */

// button icons
const starIcon = <StarIcon />;

function ButtonExamplePage(): JSX.Element {
  return (
    <section id="button" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Button</h1>
      <div className="ExamplesPage__Description">
        Buttons are the user&apos;s primary way of taking action in the UI.
      </div>

      <div className="ExamplesPage__ExampleRow mb-3">
        <Button variant={ButtonVariant.PRIMARY}>Primary</Button>
        <Button>Secondary</Button>
        <Button variant={ButtonVariant.BORDERLESS}>Borderless</Button>
      </div>

      <div className="ExamplesPage__Subhead">Small</div>
      <div className="ExamplesPage__ExampleRow mb-3">
        <Button variant={ButtonVariant.PRIMARY} size="sm">
          Primary
        </Button>
        <Button size="sm">Secondary</Button>
        <Button variant={ButtonVariant.BORDERLESS} size="sm">
          Borderless
        </Button>
      </div>

      <div className="ExamplesPage__Subhead">With Icons</div>
      <div className="ExamplesPage__ExampleRow mb-3">
        <Button variant={ButtonVariant.PRIMARY} leftIcon={starIcon}>
          Primary with Icon
        </Button>
        <Button leftIcon={starIcon}>Secondary with Icon</Button>
        <Button rightIcon={starIcon}>Right Icon</Button>
        <Button variant={ButtonVariant.BORDERLESS} leftIcon={starIcon}>
          Borderless with Icon
        </Button>
      </div>

      <div className="ExamplesPage__Subhead">Small with Icons</div>
      <div className="ExamplesPage__ExampleRow mb-3">
        <Button variant={ButtonVariant.PRIMARY} size="sm" leftIcon={starIcon}>
          Primary with Icon
        </Button>
        <Button size="sm" leftIcon={starIcon}>
          Secondary with Icon
        </Button>
        <Button size="sm" rightIcon={starIcon}>
          Right Icon
        </Button>
        <Button variant={ButtonVariant.BORDERLESS} size="sm" leftIcon={starIcon}>
          Borderless with Icon
        </Button>
      </div>

      <div className="ExamplesPage__Subhead">Disabled</div>
      <div className="ExamplesPage__ExampleRow mb-3">
        <Button variant={ButtonVariant.PRIMARY} disabled>
          Disabled Primary
        </Button>
        <Button disabled>Disabled Secondary</Button>
        <Button leftIcon={starIcon} disabled>
          Disabled with Icon
        </Button>
        <Button variant={ButtonVariant.BORDERLESS} disabled>
          Disabled Borderless
        </Button>
        <Button variant={ButtonVariant.BORDERLESS} leftIcon={starIcon} disabled>
          Borderless with Icon
        </Button>
      </div>

      <div className="ExamplesPage__UsageNotes">
        <div className="ExamplesPage__Subhead">Using Buttons</div>
        <ul>
          <li>Most buttons use the &quot;secondary&quot; style.</li>
          <li>Use &quot;primary&quot; buttons sparingly, for recommended or commonly needed actions.</li>
          <li>
            Buttons use title captilization (first, last, and important words). This is a change from our prior UI,
            which used all caps.
          </li>
        </ul>
      </div>
    </section>
  );
}
export default ButtonExamplePage;
